import { createContext, useContext } from "react";
import type { AuctionListingsSeed } from "@shared/auctionListings";

export interface SSRData {
  product?: any;
  seoData?: any;
  auction?: any;
  catalogPage?: { products: any[]; total: number };
  auctionsPage?: AuctionListingsSeed;
}

export const SSRDataContext = createContext<SSRData>({});

export function useSSRData(): SSRData {
  return useContext(SSRDataContext);
}
